import { parseISO } from 'date-fns';
import _startCase from 'lodash.startcase';

import { formatIsoDistanceToNow } from '@helpers/date';
import { vfileRoutes } from '@routes';
/**
 * @typedef MessagesListMessage
 * @prop {string} id Message ID
 * @prop {string} threadId Message thread ID
 * @prop {string} subject Message content
 * @prop {boolean} hasAttachment Does the message contain an attachment
 * @prop {boolean} isRead Is message read
 * @prop {boolean} isArchived Is message archived
 * @prop {string} messageType Message type
 * @prop {string} messageTypeLabel Message type label
 * @prop {Object} dateModified Modified date info
 * @prop {string} dateModified.label Formatted display label for date
 * @prop {Date} dateModified.date Last modified date
 * @prop {MessageParticipant} userFrom Sender details
 * @prop {MessageParticipant} participants Message participants
 */

/**
 * @typedef MessagesListModel
 * @prop {number} count Number of messages
 * @prop {Object} savedFilingPeriod Related saved filing period data
 * @prop {string} savedFilingPeriod.label Saved filing period name
 * @prop {string} savedFilingPeriod.to Link to filing
 * @prop {Array<MessagesListMessage>} messages List of messages
 */

/**
 * Transforms message list API data
 * @param {Object} $0 Message data from API
 * @param {Array<MessageApiData>} [$0.results=[]] Messages
 * @param {number} [$0.count] Number of messages
 * @param {Object} [savedFilingPeriodData] Saved filing period data
 * @returns {MessagesListModel} Transformed message list data
 */
export const messageListGetModel = ({ results = [], count }, savedFilingPeriodData) => ({
  count,
  savedFilingPeriod: savedFilingPeriodData && {
    label: `${savedFilingPeriodData.entityName} ${savedFilingPeriodData.countryIso} ${savedFilingPeriodData.filingPeriod} ${savedFilingPeriodData.filingTypeNameShort} ${savedFilingPeriodData.dateFilingDue}`,
    to: savedFilingPeriodData.id ? vfileRoutes.FILING.make(savedFilingPeriodData.id) : undefined,
  },
  messages: results.map(message => ({
    id: message.id,
    threadId: message.messageThread,
    hasAttachment: !!message.attachmentId,
    participants: message.participants,
    subject: message.subject,
    isRead: !!message.messageStatus?.read,
    isArchived: !!message.messageStatus?.archived,
    userFrom: message.userFrom,
    messageType: message.messageType,
    messageTypeLabel: message.entityCountryVatReturnSearch || _startCase(message.messageType),
    dateModified: {
      label: formatIsoDistanceToNow(message.dateModified),
      date: parseISO(message.dateModified),
    },
  })),
});
